require('../../style/base.less');
require('../../info/index.less');
require('../../icon/index.less');
require('../../tab/index.less');
require('../../sticky/index.less');
require('../../tabs/index.less');
require('../index.less');


//////////////////
// WEBPACK FOOTER
// ./node_modules/vant/lib/cascader/style/less.js
// module id = iHr2
// module chunks = 28